import { faListCheck, faPlus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BoxV4, ButtonV2, LabraToolTipV2 } from '@labrav/react-components'
import { FieldArray, FormikProps, useFormikContext } from 'formik'
import { useStyles } from './Plan.styles'
import { useMemo } from 'react'
import { isEmpty } from 'lodash'
import { PlanRow } from './PlanRow/PlanRow'
import { Product } from '../../../../modules/productsListing/reducer'
import {
  AzureOfferPlan,
  AzurePricingType,
} from '../../../../modules/privateOffer/reducer'
import { MsftCombinedFormState } from '../../../../modules/microsoftCombinedForm/reducer'
import {
  CombinedFormFAQs,
  CombinedFormFAQsItem,
} from '../CombinedFormFAQs/CombinedFormFAQs'

const emptyPlan = {
  displayName: '',
  planId: '',
  offerPricingType: 'saasNewCustomizedPlans',
  description: '',
  labraPlanId: '',
  discountPercentage: null,
  markupPercentage: null,
  discountType: AzurePricingType.ABSOLUTE,
  buyerPrice: null,
  pricing: {
    recurrentPrice: {
      recurrentPriceMode: '',
      priceInputOption: 'usd',
      prices: [],
    },
  },
}

export const Plan = ({ product }: { product: Product }) => {
  const { classes } = useStyles()
  const { values } = useFormikContext() as FormikProps<MsftCombinedFormState>

  const plans = (values?.draftOffer?.plans || []) as AzureOfferPlan[]
  const planIds = useMemo(
    () => plans.map(plan => plan?.labraPlanId || '').filter(id => !isEmpty(id)),
    [plans]
  )

  const productPlans = (product?.plans || [])?.filter(
    plan => !(plan?.isPrivate || plan?.isStopSell || plan?.hasFreeTrials)
  )

  const isDisablePlanAdd = productPlans?.length === plans?.length

  return (
    <BoxV4
      heading={'Pricing configuration'}
      headingIcon={
        <FontAwesomeIcon
          icon={faListCheck}
          style={{ width: '16px', height: '16px' }}
        />
      }
      secondaryActions={
        <CombinedFormFAQs item={CombinedFormFAQsItem.PRICING} />
      }
    >
      <div className={classes.sectionContainer}>
        <FieldArray name="draftOffer.plans">
          {({ push, remove }) => (
            <>
              {plans.map((planItem, index) => (
                <PlanRow
                  plan={planItem}
                  remove={remove}
                  index={index}
                  product={product}
                  planIds={planIds}
                />
              ))}
              <LabraToolTipV2
                tooltipPlacement="top"
                description={
                  isDisablePlanAdd
                    ? 'All your existing plans have been added above.'
                    : ''
                }
              >
                <ButtonV2
                  className={classes.widthButton}
                  styleType="link"
                  onClick={() => {
                    push(emptyPlan)
                  }}
                  data-testid="add-a-metaData-button"
                  disabled={isDisablePlanAdd}
                >
                  <FontAwesomeIcon
                    icon={faPlus}
                    width={'14px'}
                    height={'16px'}
                    style={{ paddingRight: '13px', paddingLeft: '5px' }}
                  />
                  Add plan
                </ButtonV2>
              </LabraToolTipV2>
            </>
          )}
        </FieldArray>
      </div>
    </BoxV4>
  )
}
